module.exports = __webpack_public_path__ + "img/fast-splitter-west.9a61fb5c.png";